"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isReactNode = exports.isNavigationButton = exports.isNavigationAnchor = exports.highlightSubString = exports.IS_DEV = void 0;
var _react = require("react");
const IS_DEV = exports.IS_DEV = process.env.NODE_ENV === "development";

/**
 * Find substring and wrap in <strong /> tag
 * @param {string} str - The string to search
 * @param {string} subString - The substring to find
 * @return {Obj} newStr - Object with text and match bool
 */
const highlightSubString = (str, subString) => {
  if (typeof str !== "string" || typeof subString !== "string") {
    return {
      text: str || "",
      match: false
    };
  }
  const escapedSubstring = subString.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const caseInsensitiveRegex = new RegExp(escapedSubstring, "gi");
  const newStr = str.replace(caseInsensitiveRegex, match => "<strong>".concat(match, "</strong>"));
  return {
    text: subString === "" ? str : newStr,
    match: newStr !== str
  };
};

/**
 * Whether a navigation item is an anchor.
 * @param link - The navigation item.
 */
exports.highlightSubString = highlightSubString;
const isNavigationAnchor = link => !!link.url;

/**
 * Whether a navigation item is a button.
 * @param link - The navigation item.
 */
exports.isNavigationAnchor = isNavigationAnchor;
const isNavigationButton = link => !link.url;

/**
 * A typeguard for whether an element is a ReactNode.
 */
exports.isNavigationButton = isNavigationButton;
const isReactNode = element => /*#__PURE__*/(0, _react.isValidElement)(element);
exports.isReactNode = isReactNode;